
/* injects from baggage-loader */

'use strict';

import DialogAlertController from '../alert/alert.controller';

export default class DialogFeedbackController extends DialogAlertController{
    constructor($log, $rootScope) {
        'ngInject';

        super($log, $rootScope);

        this.$log = $log;
        
        this.agent = require('_images/feedback/agent_b.png');

        this.state = {
          step: 0
        }
    }

    toNextStep(){
      this.state.step += 1;
    }  

    isLastSentence(){
      return this.state.step === ( this.resolve.texts.length - 1 )
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/feedback/feedback.controller.js